export const idRoleAdmin = 1;

export const SERVER_URL = process.env.REACT_APP_SERVER_URL;
export const ID_SYSTEM = process.env.REACT_APP_ID_SYSTEM;